import { render, staticRenderFns } from "./ReplaceRecord.vue?vue&type=template&id=1b46ce38&scoped=true&"
import script from "./ReplaceRecord.vue?vue&type=script&lang=js&"
export * from "./ReplaceRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceRecord.vue?vue&type=style&index=0&id=1b46ce38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46ce38",
  null
  
)

export default component.exports